/* eslint-disable import/prefer-default-export */
import Fetch, { V1, V2 } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';

const DEFAULT_GET_RESPONSE = {
  err_code: '500',
  err_message: '',
  result: null,
};

export const getVerifyBank = (params) => {
  const resourceUrl = `${V2}stock/rdn/verify-bank/${params.accNumber}/${params.bankId}`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

export const getBankLists = () => {
  const resourceUrl = `${V1}bank-account/banks`;
  return Fetch.get(resourceUrl)
}

export const postValidateBankAccount = (payload) => {
  const resourceUrl = `${V1}bank-account/user-bank-accounts/validate`;
  return Fetch.post(resourceUrl, payload)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};

